module.exports = __webpack_public_path__ + "static/media/juliet_zhang.55cf475b.png";